import { render, staticRenderFns } from "./dashboard.page.vue?vue&type=template&id=4fd99552&scoped=true&"
import script from "./dashboard.page.vue?vue&type=script&lang=js&"
export * from "./dashboard.page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.page.vue?vue&type=style&index=0&id=4fd99552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd99552",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
